import styled from "styled-components";
import { FooterWithLegalDocs } from "../libs";

interface FooterWithLegalDocsProps {
  isAgree?: boolean;
  setIsAgree?: (isAgree: boolean) => void;
  isAgreeMailing?: boolean;
  setIsAgreeMailing?: (isAgreeMailing: boolean) => void;
  showOferta?: boolean;
  showAgree?: boolean;
  showAgreeMailing?: boolean;
  textOferta?: string;
  countryCard?: string;
  className?: string;
  error?: string;
  t?(v: string, vars?: any): string;
}


export default function FooterWithLegalDoc(props: FooterWithLegalDocsProps) {
  const {
    isAgree,
    isAgreeMailing,
    setIsAgree,
    setIsAgreeMailing,
    error,
    textOferta
  } = props

    return (
        <StyledFooterWithLegalDoc
          isAgree={isAgree} 
          isAgreeMailing={isAgreeMailing} 
          setIsAgree={setIsAgree} 
          setIsAgreeMailing={setIsAgreeMailing} 
          showOferta={true} 
          showAgree={true} 
          showAgreeMailing={true}
          textOferta={textOferta}
          error={error ? 'Примите соглашения' : ''}
        />
    )
}

const StyledFooterWithLegalDoc = styled(FooterWithLegalDocs)`
  .ui-footerWithLegalDocs-oferta {
    font-family: Inter;
    font-weight: 500;
    font-size: 0.875rem;
    leading-trim: NONE;
    line-height: 135%;
    letter-spacing: 0%;
    vertical-align: bottom;

    line-height: 135%;
    color: #7b7b7b;

    a {
      color: #7b7b7b;
      text-decoration: underline;
      text-underline-offset: 0.1875rem;
    }
  }

  .ui-footerWithLegalDocs-agree {
    font-size: 0.875rem;
    gap: 0.75rem;

    span {
      font-family: Inter;
      font-weight: 500;
      font-size: 0.875rem;
      leading-trim: NONE;
      line-height: 135%;
      letter-spacing: 0%;
      vertical-align: bottom;
      color: #7b7b7b;
      margin: auto 0;
      
      a {
      color: rgba(71, 96, 231, 1);
        text-decoration: underline;
        text-underline-offset: 0.1875rem;
      }
    }
  }

  .ui-footerWithLegalDocs-agreeMailing {
    font-size: 0.875rem;
    gap: 0.75rem;

    span {
      font-family: Inter;
      font-weight: 500;
      font-size: 0.875rem;
      leading-trim: NONE;
      line-height: 135%;
      letter-spacing: 0%;
      vertical-align: bottom;
      color: #7b7b7b;
      margin: auto 0;
      
      a {
      color: rgba(71, 96, 231, 1);
        text-decoration: underline;
        text-underline-offset: 0.1875rem;
      }
    }
  }



  .ui-checkbox {
    margin-bottom: 0rem;
    margin-right: 0rem;
    font-size: 0.875rem;
    color: rgba(71, 96, 231, 1);
    border: 2px solid rgba(71, 96, 231, 1);

    && .box {
      border: 2px solid rgba(71, 96, 231, 1);
      width: 1.25rem;
      height: 1.25rem;
    }

    .box:has(span) {
      width: 1.25rem;
      height: 1.25rem;
      background: rgba(71, 96, 231, 1);
    }
  
    .box span {
      font-size: 0.875rem;
    }
  }
`
